var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001Past(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "line",
    height: 512,
    fill: "#0e59f2",
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.04279 7.01373 1.77459-1.18121a.99984.99984 0 0 0 -1.10738-1.66504l-4.26371 2.83789a.99965.99965 0 0 0 0 1.665l4.26371 2.83793a.99984.99984 0 0 0 1.10742-1.665l-1.07352-.71458a24.57919 24.57919 0 1 1 -28.3249 24.29028 24.41987 24.41987 0 0 1 7.19916-17.3814.99989.99989 0 0 0 -1.41406-1.41406 26.58106 26.58106 0 1 0 45.37695 18.79546 26.68028 26.68028 0 0 0 -23.53826-26.40527z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32 54.48a21.16968 21.16968 0 1 0 -21.16992-21.16945 21.19384 21.19384 0 0 0 21.16992 21.16945zm0-40.33935a19.16968 19.16968 0 1 1 -19.16992 19.1699 19.19165 19.19165 0 0 1 19.16992-19.16992z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m32 18.82764a.99974.99974 0 0 0 1-1v-1.96778a1 1 0 1 0 -2 0v1.96778a.99974.99974 0 0 0 1 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20.3457 23.06934a.9999.9999 0 0 0 1.41407-1.41407l-1.39161-1.3916a.99989.99989 0 0 0 -1.41406 1.41406z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5498 34.30957h1.96778a1 1 0 1 0 0-2h-1.96778a1 1 0 1 0 0 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19.66113 46.64893a.99676.99676 0 0 0 .707-.293l1.39161-1.3916a.9999.9999 0 1 0 -1.41407-1.41407l-1.3916 1.3916a1 1 0 0 0 .707 1.707z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m32 47.792a.99974.99974 0 0 0 -1 1v1.96778a1 1 0 0 0 2 0v-1.96778a.99974.99974 0 0 0 -1-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m43.63184 46.356a.99989.99989 0 1 0 1.41406-1.41407l-1.3916-1.3916a.9999.9999 0 0 0 -1.41407 1.41407z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m47.48242 34.30957h1.96778a1 1 0 0 0 0-2h-1.96778a1 1 0 0 0 0 2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m42.94727 23.3623a.99677.99677 0 0 0 .707-.293l1.3916-1.39161a.99989.99989 0 1 0 -1.41406-1.41406l-1.39161 1.3916a1 1 0 0 0 .707 1.707z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m23.19531 34.30957 5.84668.00092a3.12814 3.12814 0 1 0 3.95801-3.95911v-8.84845a1 1 0 0 0 -2 0v8.84845a3.13 3.13 0 0 0 -1.95844 1.95911l-5.84625-.00092a1 1 0 0 0 0 2zm8.80469-2.13672a1.137 1.137 0 1 1 -1.13672 1.13672 1.1378 1.1378 0 0 1 1.13672-1.13672z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Past);
export default __webpack_public_path__ + "static/media/001-past.cedcf2a7208aa237b51846272ee8adc1.svg";
export { ForwardRef as ReactComponent };